import { tableLink } from './MarketStatistics';
import commonUtils from '../../../../../utils/commonUtils';

export interface IABSAdvertisementData {
  imageUrl: string;
  linkUrl: string;
  title?: string;
  videoUrl?: string;
  type?: number;
}

export function columnsData() {
  const data = [
    {
      title: '类别',
      dataIndex: 'ProductType',
      render: (text, record) => {
        return tableLink(text, record.ProductTypeId);
      }
    },
    {
      title: '今年发行',
      dataIndex: 'TotalOfferingCurryear',
      className: 'abs-right',
      render: (text, record) => {
        return commonUtils.formatContent(text, true, false, true, 0, 8, false );
      }
    },
    {
      title: '累计发行',
      dataIndex: 'TotalOffering',
      className: 'abs-right',
      render: (text, record) => {
        return commonUtils.formatContent(text, true, false, true, 0, 8, false);
      }
    },
    {
      title: '存量',
      dataIndex: 'TotalOfferingUnpaydown',
      className: 'abs-right',
      render: (text, record) => {
        return commonUtils.formatContent(text, true, false, true, 0, 8, false);
      }
    },
    {
      title: '二级交易',
      dataIndex: 'SecondTradeSum',
      className: 'abs-right',
      render: (text, record) => {
        return commonUtils.formatContent(text, true, false, true, 0, 8, false);
      }
    }
  ];
  return data;
}

// 格式化筛选条件
export function formatAdvertisement(data: any) {
  const listLeft: IABSAdvertisementData[] = [];
  const listRight: IABSAdvertisementData[] = [];
  const response = { 'left': listLeft, 'right': listRight };
  data.forEach(element => {
    if (element.type === 1) {
      response.left.push({
        imageUrl: element.imgurl,
        linkUrl: element.url,
        title: element.title,
      });
    }
    if (element.type === 2) {
      response.right.push({
        imageUrl: element.imgurl,
        linkUrl: element.url,
        title: element.title,
      });
    }
  });
  return response;
}

// 单个广告格式化筛选条件
export function formatSingleAdvertisement(data: any) {
  const list: IABSAdvertisementData[] = [];
  data.forEach(element => {
    list.push({
      videoUrl: element.video_url,
      imageUrl: element.imgurl,
      linkUrl: element.url,
      title: element.title,
      type: element.type,
    });
  });
  return list;
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/home/component/middle/util.ts